"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownMenu = void 0;

var _colors = _interopRequireDefault(require("../colors"));

var dropdownMenu = {
  colors: {
    menu: {
      backgroundColor: _colors["default"].basic.white
    },
    item: {
      "default": {
        fontColor: _colors["default"].secondary.dark,
        fontColorHover: _colors["default"].secondary.dark,
        iconColor: _colors["default"].tertiary.darker,
        iconColorHover: _colors["default"].tertiary.darker,
        backgroundColorHover: _colors["default"].tertiary.light
      },
      primary: {
        fontColor: _colors["default"].primary.main,
        fontColorHover: _colors["default"].primary.main,
        iconColor: _colors["default"].primary.main,
        iconColorHover: _colors["default"].primary.main,
        backgroundColorHover: _colors["default"].tertiary.light
      },
      danger: {
        fontColor: _colors["default"].danger.main,
        fontColorHover: _colors["default"].danger.main,
        iconColor: _colors["default"].danger.main,
        iconColorHover: _colors["default"].danger.main,
        backgroundColorHover: _colors["default"].tertiary.light
      },
      dangerHover: {
        fontColor: _colors["default"].secondary.dark,
        fontColorHover: _colors["default"].danger.main,
        iconColor: _colors["default"].tertiary.darker,
        iconColorHover: _colors["default"].danger.main,
        backgroundColorHover: _colors["default"].tertiary.light
      }
    }
  }
};
exports.dropdownMenu = dropdownMenu;